<div>
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="backupMentors()"></grid-content>
</div>